export const TREE_MIN_COLUMN_WIDTH = 180;
export const ROLE_MIN_COLUMN_WIDTH = 18;
export const ROLE_COLUMN_WIDTH = 132;
export const CHAIN_MIN_COLUMN_WIDTH = 27;
export const CHAIN_COLUMN_WIDTH = 120;
export const EXCLUDED_MIN_COLUMN_WIDTH = 28;
export const EXCLUDED_COLUMN_WIDTH = 34;
export const TREE_NODE_INDENT_STEP_PX = 6;
export const TREE_NODE_BASE_LEFT_OFFSET_PX = 4;
export const ROW_HORIZONTAL_PADDING_TOTAL = 12; // px-1.5
export const ROW_VERTICAL_PADDING_PX = 1; // py-0.5
export const ROW_BADGE_HEIGHT_PX = 16;
export const ROW_COLUMN_GAP_PX = 8; // gap-x-2
